import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { Shape } from './shape'

@Directive({
  selector: '[appShapeSelect]',
})
export class ShapeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'packaging.shape.title'
    this.select.displayProperty = 'displayValue'
    this.select.dataSource = enumTranslationService.enumDataSource(Shape, 'packaging.shape', false)
  }
}
